// In MainPage.js
import React from 'react';
import HeroSection from './HeroSection';
import ResourcesSection from './ResourcesSection';
import TakeawaySection from './TakeawaySection'
import MapSection from './MapSection';
import ReportSection from './ReportSection';

const MainPage = () => {
  return (
    <div className="main-page">
      <HeroSection />
      <MapSection />
      <ReportSection />
      <TakeawaySection />
      <ResourcesSection />
    </div>
  );
};

export default MainPage;
